<template>
  <div>
    <Header />
    <div class="information">
    <div class="intro">
      <img :src="'/' + item.product_image_path + item.image_stre_file_name" alt="">
      <h2 class="title title--h2 mt40">
        {{item.brand_product_name}}
      </h2>
    </div>
    <div class="description-section mt60">
      <h2 class="title title--h2 title--bg">상품 상세 정보</h2>
      <div v-html="item.product_det_bdt" class="data-inner"></div>
    </div>
    <div class="information-section mt40">
      <h2 class="title title--h2 title--bg">
        환불규정 및 유의사항
      </h2>
      <!-- <div v-html="item.rfnd_rgln_use_desc_bdt" class="data-inner"></div> -->
      <div class="data-inner">
        <div v-if="item.rfnd_rgln_use_desc_bdt" class="info-group">
          <strong>환불규정 및 유의사항</strong>
          <div v-html="item.rfnd_rgln_use_desc_bdt"></div>
        </div>
        <div  v-if="item.xcg_bhf_bdt" class="info-group">
          <strong>교환지점안내</strong>
          <div v-html="item.xcg_bhf_bdt"></div>
        </div>
        <div v-if="item.add_words_bdt" class="info-group">
          <strong>추가문구</strong>
          <div v-html="item.add_words_bdt"></div>
        </div>
      </div>
    </div>
    <div class="contact mt60">
      <div class="contact__row">
        <div class="contact__column contact__column--title">
          발행자
        </div>
        <div class="contact__column contact__column--contents">
          기프티엘
        </div>
      </div>
      <div class="contact__row">
        <div class="scontact__column contact__column--title">
          고객센터
        </div>
        <div class="contact__column contact__column--contents">
          1644-4276
        </div>
      </div>
    </div>
    <div class="image-box" v-html="item.ad_bdt">
    </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Header from '@/components/Header';
import axios from 'axios';

export default {
  name: "Information",
  components: {
    Header
  },
  data() {
    return {
      item: {
        brand_product_name : '',
        product_det_bdt : '',
        image_orgnl_file_name : '',
        image_stre_file_name: '',
        image_file_byte: '',
        product_image_path: '',
        rfnd_rgln_use_desc_bdt: '',
        xcg_bhf_bdt: '',
        add_words_bdt: '',
        ad_bdt: ''
      }
    }
  },
  created(){
    const pin = this.$route.params.pin;
    axios.post(process.env.ENDPOINT+'/use/guide', {
      pin: pin
    })
    .then(response => {
      if(response.status === 200){
        const data1 = response.data.response.data1 ? response.data.response.data1 : '';
        const data2 = response.data.response.data2 ? response.data.response.data2 : '';
        // const data2 = response.data.response.data2;

        this.item.brand_product_name = !!data1.product_det_name ? data1.product_det_name : data1.brand_product_name;
        this.item.product_det_bdt = data1.product_det_bdt;
        this.item.image_orgnl_file_name = data1.image_orgnl_file_name;
        this.item.image_stre_file_name = data1.image_stre_file_name;
        this.item.image_file_byte = data1.image_file_byte;
        this.item.product_image_path= data1.product_image_path;

        this.item.rfnd_rgln_use_desc_bdt = data2.rfnd_rgln_use_desc_bdt; //환불규정 및 유의사항
        this.item.xcg_bhf_bdt = data2.xcg_bhf_bdt; // 교환지점안내
        this.item.add_words_bdt = data2.add_words_bdt; // 추가문구
        this.item.ad_bdt = data2.ad_bdt; // 광고

        console.log(response.data.response);
      }
    })
    .catch(error => {
      console.log(error);
    });
  }
};
</script>

<style scoped lang='scss'>

@import '@/assets/styles/mixin.scss';

.information {
  width: 100%;
  margin: 0 auto;
  color: #666;
  letter-spacing: -0.5px;
  box-shadow: 0px 8px 14px -5px #e5e5e5 inset;

  h2{
    line-height: 24px;
  }
  .intro {
    text-align: center;
    padding: 20px 20px 0;
  }
  .contact {
    background-color: #f5f5f5;
    padding: 15px 20px;
    &__row {
      @include flexbox();
      @include align-items(center);
      &:nth-child(2) {
        margin-top: calc(15px - 5px);
      }
    }
    &__column {
      &--title {
        width: 72px;
        font-size: 12px;
      }
      &--contents {
        width: calc(100% - 72px);
        font-size: 14px;
        color: #222;
      }
    }
  }
}
img {
  width: 100%;
}

.data-inner {
  padding: 20px;
}
.title {
  color: #222;
  padding: 0 20px;
  &--h2 {
    font-size: 16px;
    font-weight: 500;
  }
  &--h3 {
    font-size: 14px;
  }
  &--bg {
    background-color: #eee;
    padding: 12.5px 20px;
  }
}
.description {
  font-size: 14px;
  padding: 0 20px;
  line-height: 21px;
  &--color-defalut {
    color: #222;
  }
  &--line-height-48 {
    line-height: 24px;
    margin-top: -2.5px;
    &:nth-child(2) {
      margin-top: 0px;
    }
  }
}
.bullet-point {
  display: table-cell;
  &--pr5 {
    padding-right: 2.5px;
  }
}
.info-group{
  strong{
    display:block;
    font-size:14px;
    color:#222;
  }
  & ~ .info-group{
    margin:20px 0 0 0;
  }
}
.mt20 {
  margin-top: calc(10px - 7.5px); // line-height 값 제거
}
.mt40 {
  margin-top: 20px;
}
.mt60 {
  margin-top: 30px;
}
</style>



// WEBPACK FOOTER //
// src/views/Information.vue